import handler from 'api/handler'

const prefix = '/userAdmin/pushSubscription'

const methods = {
  subscribe: args => handler({ method: 'post', url: prefix + '/subscribe', args }),
  unsubscribe: args => handler({ method: 'delete', url: prefix + '/unsubscribe', args }),
  getPublicKey: () => handler({ method: 'get', url: prefix + '/publicKey' })
}

export default methods

